import { Component, OnInit } from '@angular/core';
import { DeviceDetectService } from '../../services/device-detect.service';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss']
})
export class AppHeaderComponent implements OnInit {
  isMobile: boolean = false;
  mobileMenuOpen: boolean = false;

  constructor(private deviceDetectService: DeviceDetectService) {}

  ngOnInit(): void {
    this.isMobile = this.deviceDetectService.getIsMobile();
  }

  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }
}

